import { createRouter, createWebHashHistory } from 'vue-router'
import { useFormDataStore } from '@/store/formData'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/basicInfo',
    name: 'BasicInfo',
    component: () => import('../views/BasicInfo.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/select',
    name: 'Select',
    component: () => import('../views/Select.vue'),
    meta: {
      needUserCode: true
    }
  },
  {
    path: '/academic',
    name: 'Academic',
    component: () => import('../views/Academic.vue'),
    meta: {
      needUserCode: true
    }
  },
  {
    path: '/feedBack',
    name: 'FeedBack',
    component: () => import('../views/FeedBack.vue'),
    meta: {
      needUserCode: true
    }
  },
  {
    path: '/report',
    name: 'Report',
    component: () => import('../views/Report.vue'),
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  let userCode = localStorage.getItem('userCode');
  if ((to.meta.needUserCode && !userCode)) {
    next('/');
  } else {
    next();
  }
})

export default router